module.exports = __webpack_public_path__ + "img/mail_chimp.88b3adda.svg";